import styled from 'styled-components';

export const MobileSortBarInfoBadgesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }

  svg {
    width: 32px;
    height: 32px;
  }
`;
